"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _TextField = _interopRequireDefault(require("../TextField"));
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _Spinner = _interopRequireDefault(require("../Spinner"));
var _Chip = _interopRequireDefault(require("../Chip"));
var _Button = _interopRequireDefault(require("../Button"));
var _NotificationBannerInline = _interopRequireDefault(require("../NotificationBannerInline"));
var _SearchBookingModal = _interopRequireDefault(require("./SearchBookingModal.proptypes"));
var _constant = require("./constant");
var _constant2 = require("../JourneyPriceCTA/constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var InitialTag = _styledComponents.default.div.withConfig({
  displayName: "SearchBookingModal__InitialTag",
  componentId: "sc-hxzolp-0"
})([""]);
var ChipWrapper = _styledComponents.default.span.withConfig({
  displayName: "SearchBookingModal__ChipWrapper",
  componentId: "sc-hxzolp-1"
})(function (_ref) {
  var theme = _ref.theme;
  return "\n    display: flex;\n    flex-direction: 'row';\n    margin-right: ".concat(theme.space.XSmall, ";\n    margin-bottom: ").concat(theme.space.XSmall, ";\n    gap: 10px;\n    padding: ", "0 ".concat(theme.space.tiny), ";\n  ");
});
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchBookingModal__Wrapper",
  componentId: "sc-hxzolp-2"
})(["display:flex;flex-direction:column;width:100%;"]);
var MainWrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchBookingModal__MainWrapper",
  componentId: "sc-hxzolp-3"
})(["padding:", ";"], function (_ref2) {
  var theme = _ref2.theme,
    isMobile = _ref2.isMobile;
  return !isMobile ? "".concat(theme.space.small, " ").concat(theme.space.standard) : "".concat(theme.space.small);
});
var BodySectionWrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchBookingModal__BodySectionWrapper",
  componentId: "sc-hxzolp-4"
})(["display:flex;flex-direction:", ";justify-content:space-between;"], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 'column' : 'row';
});
var SearchBookingModalCopy = function SearchBookingModalCopy(props) {
  var theme = props.theme,
    translation = props.translation,
    COUNTRY_LIST = props.COUNTRY_LIST,
    data = props.data,
    activeBackgroundColor = props.activeBackgroundColor,
    activeBorderColor = props.activeBorderColor,
    onSearchClick = props.onSearchClick,
    onViewBookingsClick = props.onViewBookingsClick,
    hoverTextColor = props.hoverTextColor,
    hoverBackgroundColor = props.hoverBackgroundColor,
    hoverBorderColor = props.hoverBorderColor,
    isMobile = props.isMobile,
    isLoading = props.isLoading,
    showHotelRetriveBookingBanner = props.showHotelRetriveBookingBanner,
    stationsObj = props.stationsObj,
    setSelectedValue = props.setSelectedValue,
    showInvalidBookingBanner = props.showInvalidBookingBanner;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    showModal = _useState2[0],
    setShowModal = _useState2[1];
  var _useState3 = (0, _react.useState)(data[0].mainLabel),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    bookingLabel = _useState4[0],
    setBookingLabel = _useState4[1];
  var _useState5 = (0, _react.useState)({
      type: data[0].mainLabel,
      fields: {}
    }),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    form = _useState6[0],
    setForm = _useState6[1];
  var move = theme === _constant2.THEMES.MOVE;
  var handleSingleChipClick = function handleSingleChipClick(selectedOption) {
    form.type = selectedOption;
    form.fields = {};
    setForm(form);
    setBookingLabel(selectedOption);
    setSelectedValue(selectedOption);
  };
  var handleChipClick = function handleChipClick(selectedOption) {
    // eslint-disable-next-line no-shadow
    var ansObj = data && data.find(function (_ref4) {
      var label = _ref4.label;
      return label === selectedOption;
    });
    if (ansObj) handleSingleChipClick(selectedOption, ansObj.value);else handleSingleChipClick(selectedOption);
  };
  var checkActive = function checkActive(selectedOption) {
    return selectedOption === bookingLabel;
  };
  var language = _objectSpread(_objectSpread({}, _constant.TRANSLATION), translation);
  var searchHandler = function searchHandler() {
    onSearchClick(form);
  };
  var viewAllBookingsHandler = function viewAllBookingsHandler() {
    onViewBookingsClick(true);
  };
  var hotelRetriveBookingBannerMessage = [{
    text: language.hotelNotificationBannerText,
    cta: language.hotelNotificationBannercta,
    url: language.hotelNotificationBannerURL,
    newTab: 'TRUE'
  }];
  var invalidBookingBannerMessage = [{
    text: language.invalidBookingNOtificationBannerText
  }];
  var getChipList = function getChipList() {
    return /*#__PURE__*/_react.default.createElement(ChipWrapper, {
      key: "",
      viewport: "mobile",
      isFirstMyOrdersFilter: false
    },
    // eslint-disable-next-line react/prop-types
    data.map(function (_ref5) {
      var mainLabel = _ref5.mainLabel;
      return /*#__PURE__*/_react.default.createElement(_Chip.default, {
        activeBackgroundColor: activeBackgroundColor,
        activeBorderColor: activeBorderColor,
        hoverBackgroundColor: hoverBackgroundColor,
        hoverBorderColor: hoverBorderColor,
        hoverTextColor: hoverTextColor,
        onChipClick: function onChipClick() {
          return handleChipClick(mainLabel);
        },
        active: checkActive(mainLabel)
      }, language[mainLabel]);
    }));
  };
  var getText = function getText(children, TYPE, marginBottom, bold, _color) {
    return /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: true,
      display: "inlineFlex",
      tag: "p",
      theme: "AIRASIA_CLASSIC",
      type: TYPE,
      marginBottom: marginBottom,
      bold: bold,
      color: _color
    }, children);
  };
  var filterList = function filterList(inputValue, callback, items) {
    var result = inputValue && inputValue !== '' && inputValue !== null ? items.filter(function (option) {
      return option.value.toLowerCase().startsWith(inputValue.toLowerCase()) || option.mainDisplayName.toLowerCase().startsWith(inputValue.toLowerCase());
    }) : COUNTRY_LIST;
    callback(result);
  };
  var getInitialTag = function getInitialTag() {
    var iconAndText = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: true,
      color: "neutral",
      fontsize: "default",
      icon: "Search",
      theme: "AIRASIA_CLASSIC"
    }), language.firstLabel);
    return getText(iconAndText);
  };
  var getHeader = function getHeader() {
    return /*#__PURE__*/_react.default.createElement("div", {
      style: {
        marginBottom: '15px'
      }
    }, getText(language.title, 'titleNormal', 'none', true, 'neutral'), /*#__PURE__*/_react.default.createElement("br", null), getText(language.subTitle, 'default', 'none', false, 'greyDarker'));
  };
  var getNotificationBannerInline = function getNotificationBannerInline(bannerData, bannerType, bannerColor, isBannerClickable) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_NotificationBannerInline.default, {
      theme: "AIRASIA_CLASSIC",
      message: bannerData,
      type: bannerType,
      fullWidth: true,
      textType: "default",
      border: false,
      ctaColor: bannerColor,
      ctaSize: "XSmall",
      isBannerClickable: isBannerClickable
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        height: '5px'
      }
    }));
  };
  var getTextWrapper = function getTextWrapper(inputLabel) {
    return /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(_TextField.default, {
      accessible: true,
      alignContentRight: false,
      alwaysShowLabel: false,
      forceUpperCase: false,
      isDate: false,
      label: inputLabel.label,
      labelMarginBottomLarge: false,
      onChange: function onChange(obj) {
        form.fields[inputLabel.key] = obj.target.value;
        setForm(form);
      },
      showIcon: true,
      theme: "AIRASIA_CLASSIC",
      type: "text"
    }));
  };
  var loadForm = function loadForm() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, bookingLabel.toLowerCase() === _constant.HOTEL_BOOKING_LABEL && showHotelRetriveBookingBanner && getNotificationBannerInline(hotelRetriveBookingBannerMessage, 'warning', 'yellow', true), data.find(function (e) {
      return e.mainLabel === bookingLabel;
    }).inputLabels.map(function (inputLabel) {
      var isDestinationCity = inputLabel.key === 'departureCity';
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isDestinationCity && /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
        theme: theme,
        viewPort: isMobile ? 'isMobile' : 'desktop',
        label: inputLabel.label,
        items: stationsObj,
        onSelect: function onSelect(obj) {
          form.fields[inputLabel.key] = obj.value;
          setForm(form);
        },
        onChange: filterList,
        isNewVersion: true,
        alwaysShowLabel: false,
        supportOneCharacterSearch: true,
        showOptionsfromTop: true
      }), !isDestinationCity && bookingLabel === data[0].mainLabel && getTextWrapper(inputLabel), !isDestinationCity && bookingLabel === data[1].mainLabel && getTextWrapper(inputLabel), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: '10px'
        }
      }));
    }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_Button.default, {
      backgroundColor: "primary",
      color: move ? 'secondary' : 'default',
      theme: theme,
      handleClick: searchHandler,
      border: move ? 'secondary' : 'default',
      width: "100%",
      customProperties: {
        paddingLeft: '0',
        paddingRight: '0',
        gap: '8px'
      }
    }, isLoading ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      height: "20",
      width: "20",
      color: "default",
      animationDuration: "1s",
      show: true,
      strokeWidth: "4",
      theme: theme
    }) : language.search), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        margin: '35px 0'
      }
    }, /*#__PURE__*/_react.default.createElement("p", {
      style: {
        color: '#5a5d63',
        width: '100%',
        textAlign: 'center',
        borderBottom: '0.7px solid #d9dbe0',
        lineHeight: '.1em'
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      style: {
        background: '#fff',
        padding: '0 19px',
        fontSize: '14px'
      }
    }, "Or"))), /*#__PURE__*/_react.default.createElement(_Button.default, {
      backgroundColor: "default",
      color: move ? 'secondary' : 'primary',
      theme: theme,
      handleClick: viewAllBookingsHandler,
      border: move ? 'secondary' : 'default',
      width: "100%",
      customProperties: {
        paddingLeft: '0',
        paddingRight: '0',
        gap: '0'
      }
    }, language.viewBookings));
  };
  var getModalContent = function getModalContent(_isMobile) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(MainWrapper, {
      isMobile: _isMobile
    }, getHeader(), showInvalidBookingBanner && getNotificationBannerInline(invalidBookingBannerMessage, 'error', 'red', false), /*#__PURE__*/_react.default.createElement(BodySectionWrapper, {
      isMobile: _isMobile
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: _isMobile ? '100%' : '45%'
      }
    }, getChipList(), bookingLabel && loadForm()), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: _isMobile ? '100%' : '45%',
        marginTop: _isMobile ? '20px' : 0
      }
    }, getText(language.searchInstructions, 'default', 'small', true, 'neutral'), getText(language.searchInstruction1, 'default', 'small', false, 'neutral'), getText(language.searchInstruction2, 'default', 'small', false, 'neutral'), getText(language.searchInstruction3, 'default', 'small', false, 'neutral')))));
  };
  var renderModal = function renderModal(_isMobile) {
    return /*#__PURE__*/_react.default.createElement(_Modal.default, {
      accessible: true,
      backgroundColor: "default",
      customContentProperties: {},
      customHeaderPadding: null,
      fixedCloseBtn: false,
      hasHeaderShadow: false,
      headerPaddingBottom: "small",
      headerTextColor: null,
      isDropdown: false,
      isPreventClose: false,
      modalCenter: false,
      modalContentOverflow: "auto",
      modalContentPaddingTop: "small",
      modalRightAlign: false,
      openModal: showModal,
      overlayBackgroundColor: "black",
      overlayOpacity: "0.8",
      showCloseIcon: true,
      showHeaderBorder: true,
      isMobile: _isMobile,
      theme: "AIRASIA_CLASSIC",
      viewPort: "desktop",
      zIndex: 20,
      onClose: function onClose() {
        return setShowModal(false);
      }
    }, getModalContent(isMobile));
  };
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(InitialTag, {
      onClick: function onClick() {
        return setShowModal(true);
      }
    }, getInitialTag()), renderModal(isMobile));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
SearchBookingModalCopy.propTypes = _SearchBookingModal.default.PropTypes;
SearchBookingModalCopy.defaultProps = _SearchBookingModal.default.DefaultProps;
var _default = SearchBookingModalCopy;
exports.default = _default;